import type { FunctionComponent } from "react";
import UsuarioVerificado from "@/assets/img/user-verificado.svg";

interface ImagenUsuarioProps {
    image: string
    fullName: string
    validado: boolean
}

const ImagenUsuario: FunctionComponent<ImagenUsuarioProps> = ({
    fullName, image, validado
}) => {
    return (
        <>
        <div className="relative flex-shrink-0">
            <img 
                src={`${image}`} 
                alt={`imagen de usuario ${fullName}`} 
                className="w-20 h-20 sm:w-20 sm:h-20 md:w-[5.625rem] md:h-[5.625rem] object-cover rounded-full" 
            />
            {
                validado
                ? <img 
                    src={UsuarioVerificado} 
                    alt={`imagen de Usuario ${fullName} Verificado`} 
                    className="absolute right-0 bottom-0 w-6 h-6 md:w-7 md:h-7 transform translate-y-1 md:translate-y-0" 
                />
                : null
            }
        </div>
        </>
    );
}

export default ImagenUsuario;